export default __webpack_public_path__ + "static/broadcastImg3-987f04d0683420b395d8ab1118e62b9b.png";